import { createContext, useContext } from 'react';

export type Theme = 'light' | 'dark';
export type AccentColor = 'indigo' | 'blue' | 'purple' | 'green' | 'rose' | 'amber';

export const ThemeContext = createContext<{
  theme: Theme;
  accentColor: AccentColor;
  setTheme: (theme: Theme) => void;
  setAccentColor: (color: AccentColor) => void;
}>({
  theme: 'light',
  accentColor: 'indigo',
  setTheme: () => {},
  setAccentColor: () => {},
});

export const useTheme = () => useContext(ThemeContext);